export default {
    BlockUser : 'BlockUser',
    ReportUser : 'ReportUser',
    UnBlockUser : 'UnBlockUser',
}
